export default "__VITE_ASSET__DVca$Vkg__"